import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslocoRootModule } from "@translocoRootModule";
import { SharedModule } from "../shared/shared.module";
import { RecordInterviewRoutingModule } from "./record-interview-routing.module";
import { RecordInterviewComponent } from "./record-interview.component";

@NgModule({
  declarations: [RecordInterviewComponent],
  imports: [
    CommonModule,
    RecordInterviewRoutingModule,
    SharedModule,
    // NgcCookieConsentModule,
    TranslocoRootModule,
  ],
})
export class RecordInterviewModule {}
